import TYPES from './types';
import AUTH_TYPES from 'store/auth/types';

const INITIAL_STATE = {};

const reducer = (state = { ...INITIAL_STATE }, { type, payload }) => {
  switch (type) {
    case TYPES.GET_ACCOUNT.SUCCESS:
      return {
        ...payload
      };

    case TYPES.UPDATE_ACCOUNT.SUCCESS:
      return {
        ...state,
        ...payload
      };

    case TYPES.UPDATE_LAST_DASHBOARD_ID.SUCCESS: {
      return { ...state, last_dashboard_id: payload.last_dashboard_id };
    }

    case AUTH_TYPES.LOGOUT_CLEANUP:
      return {};

    default:
      return state;
  }
};

export default reducer;
